import clsx from 'clsx'

import classes from './NestedLevel.module.css'

const BASE_LEVEL = 1

export function NestedLevel({
  level = BASE_LEVEL,
  lastChild = false,
  children,
}) {
  if (level === BASE_LEVEL - 1) {
    return children
  }
  return (
    <div
      className={clsx(
        classes.nestedLevel,
        lastChild && level === BASE_LEVEL && classes.nestedLevelLastChild,
      )}
    >
      <NestedLevel level={level - 1} lastChild={lastChild}>
        {children}
      </NestedLevel>
    </div>
  )
}
